import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CallCenterService } from 'src/app/services/call-center.service';
import { AskApolloService } from 'src/app/services/ask-apollo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageServiceService } from 'src/app/services/message-service.service';
import { CalendarUtilityService } from 'src/app/services/calendar-utility.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HealthCheckService } from 'src/app/services/health-check.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonMethods } from 'src/app/shared/CommonMethods';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ask-apollo-corp-appointments-history',
  templateUrl: './ask-apollo-corp-appointments-history.component.html',
  styleUrls: ['./ask-apollo-corp-appointments-history.component.scss']
})
export class AskApolloCorpAppointmentsHistoryComponent implements OnInit, OnDestroy {

  //popup
  displayPopup: boolean = false;
  confirmModalRef: BsModalRef;
  @ViewChild('confirmTemplate', { static: false }) confirmTemplate: TemplateRef<any>;
  config = {
    keyboard: false,
    backdrop: true,
    ignoreBackdropClick: true
  }

  modalTitle;
  selectedApptDetails;
  isRescheduleApptOpen: boolean = false;
  isCancelApptPopupOpen: boolean = false;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;
  loadingFlag: boolean = false;
  callType;
  leadId;
  isNewUser;
  CallerStatusAutoId;
  tabItems: any;
  activeItem: any;
  patientName: string;
  patientEmail; string;
  patientMobile: string = "9493888651"; //9491898828, 9493888651
  patientUHIDMobile: string = "";
  showBasicDetailsTable: boolean = false;
  showAppointmentHistory: boolean = true;
  showCallHistory: boolean = false;
  showHCAppointmentHistory: boolean = false;
  showCorpHCAppointmentHistory: boolean = false;
  datesData: any[];
  slotsData: any;
  isCancelConfirmed: boolean = true;
  rescheduleAppointmentForm: FormGroup;
  selectedCurrentState$ : Subscription;
  selectedViewHistory$ : Subscription;

  constructor(
    private callCenterService: CallCenterService,
    private hcService: HealthCheckService,
    private formBuilder: FormBuilder,
    private askApolloService: AskApolloService,
    private messageService: MessageServiceService,
    private modalService: BsModalService,
    private ref: ChangeDetectorRef,
    private calendarService: CalendarUtilityService,
    private router: Router,
  ) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        console.log('prev:', event.url);
      });
    //this method get the selected uhid data from service
    this.selectedViewHistory$ = this.callCenterService.selectedViewHistory.subscribe(value => {
      if (value.isRequestFormPopUp && value.CallerMobileNumber && value.CallerMobileNumber.length == 10) {
        this.showBasicDetailsTable = true;
        this.leadId = value.leadId;
        this.callType = value.callType;
        this.CallerStatusAutoId = value.CallerStatusAutoId;
        this.patientEmail = value.PatientDetails["emailId"];
        this.patientMobile = value.CallerMobileNumber;//value.isNewUser ? value.PatientDetails["phoneNo"] :  value.PatientDetails["mobileNumber"] ;
        this.patientUHIDMobile = value.UHIDMobileNumber;//value.isNewUser ? value.PatientDetails["phoneNo"] :  value.PatientDetails["mobileNumber"] ;
        this.patientName = value.PatientDetails["firstName"] + " " + value.PatientDetails["lastName"];
        // this.getCallHistoryOnMobileNumber(this.patientMobile);
        this.getAppointmentsHistoryOnMobileNumber(this.patientUHIDMobile);
      }
      else {
        this.showBasicDetailsTable = false;
        // this.getCallHistoryOnMobileNumber(this.patientMobile);
        this.getAppointmentsHistoryOnMobileNumber(this.patientUHIDMobile);
      }
    });
    //this method get the status of operation done in any child tab like appt book, call status updating, reschedule etc.
    this.selectedCurrentState$ = this.callCenterService.selectedCurrentState.subscribe(value => {
      if (value && value.isOperationDone) {
        //this.closeConfirmModal();          
        this.getAppointmentsHistoryOnMobileNumber(this.patientUHIDMobile);
        // this.getCallHistoryOnMobileNumber(this.patientMobile);
      }
    });

  }

  ngOnInit() {
    this.rescheduleAppointmentForm = this.formBuilder.group({
      appointmentDate: ['', Validators.required],
      appointmentSlot: ['', [Validators.required, Validators.min(1)]],
      statusRemarks: ['']
    });

  }

  ngOnDestroy(): void {
    this.selectedCurrentState$.unsubscribe();
    this.selectedViewHistory$.unsubscribe();
  }

  appointmentsHistory = [];
  isLoading: boolean = false
  callHistoryIsLoading: boolean = false
  getAppointmentsHistoryOnMobileNumber(mobileNo) {
    this.appointmentsHistory = [];
    this.appointmentsHistory['UpcomingAppointments'] = [];
    this.appointmentsHistory['PastAppointments'] = [];
    let payload = {
      "mobileNumber": mobileNo //'9491898828'
    }
    this.loadingFlag = true;
    this.hcService.getCorporateAppointmentsHistoryOnMobileNumberFromAskApollo(payload)
      .subscribe((res: any) => {
        this.appointmentsHistory['UpcomingAppointments'] = res.UpcomingAppointments;
        this.appointmentsHistory['PastAppointments'] = res.PastAppointments;
        this.loadingFlag = false;
      }, error => {
        this.loadingFlag = false;
        this.messageService.showErrorMessage("Unable to retrieve appointment history data from server ");
      })
  }

  showModalDialog(apptDetails, type) {
    this.confirmModalRef = this.modalService.show(this.confirmTemplate, Object.assign({}, this.config, { class: 'gray modal-lg modal-dialog-centered' }));
    let callStatusObj;
    this.selectedApptDetails = apptDetails;
    if (type == "cancel") {
      callStatusObj = this.callType == 2 ? { callCenterStatusId: 23, statusName: "Cancel Appointment" } : { callCenterStatusId: 23, statusName: "Cancel Appointment" };
      this.modalTitle = "Cancel Appointment";
      this.statusRemarks = "";
      this.isCancelApptPopupOpen = true;
      this.isRescheduleApptOpen = false;
      this.callCenterService.ProceedToCancelAppt({
        "CallTypeId": this.callType,
        "CallStatus": callStatusObj,
        "LeadId": this.leadId,
        "IsNewUser": this.isNewUser,
        "CallerStatusAutoId": this.CallerStatusAutoId,
        "RescheduleDetails": this.selectedApptDetails
      });

    } else {
      callStatusObj = this.callType == 2 ? { callCenterStatusId: 16, statusName: "Rescheduling" } : { callCenterStatusId: 16, statusName: "Rescheduling" };
      this.modalTitle = "Reschedule Appointment";
      this.rescheduleAppointmentForm.get('statusRemarks').setValue('');
      this.rescheduleAppointmentForm.get('appointmentDate').setValue('');
      this.rescheduleAppointmentForm.get('appointmentSlot').setValue('');
      this.isRescheduleApptOpen = true;
      this.isCancelApptPopupOpen = false;
      this.callCenterService.ProceedToReschedule({
        "CallTypeId": this.callType,
        "CallStatus": callStatusObj,
        "LeadId": this.leadId,
        "IsNewUser": this.isNewUser,
        "CallerStatusAutoId": this.CallerStatusAutoId,
        "RescheduleDetails": this.selectedApptDetails
      });
    }

  }

  closeConfirmModal() {
    this.confirmModalRef.hide();
  }


  selectedAppointmentDate = '';
  getSlots(apptDate) {
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = (dd.getMonth() + 1) + "";
    let year = dd.getFullYear();
    apptDate = (date.length == 1 ? '0' + date : date) + '/' + (month.length == 1 ? '0' + month : month) + '/' + year;
    this.selectedAppointmentDate = apptDate;
    this.getAvailableSlots();
  }


  getAvailableSlots() {
    let data = {
      hospitalId: this.selectedApptDetails.hospitalId,
      appointmentDate: this.selectedAppointmentDate,
    }

    this.hcService.GetAllAvailableSlots(data).subscribe((res: any) => {
      if (res['corporateHCSlotsList'].length > 0) {
        this.slotsData = res['corporateHCSlotsList'];
      } else {
        this.messageService.showErrorMessage("No slots available on selected date.");
      }
    }, error => {
      this.messageService.showErrorMessage("Unable to retrieve available slots data from server ");
    })
  }

  RescheduleAppointment() {
    let UserId = JSON.parse(localStorage.getItem('LOGGED_USER_INFO')).roleId;
    let formDataValues = this.rescheduleAppointmentForm.value;
    let slotObj = this.slotsData.find(o => o.slotId == formDataValues.appointmentSlot);

    let payload = {
      "appointmentId": this.selectedApptDetails.appointmentId,
      "appointmentDate": CommonMethods.changeDateFormatDDMMYYYY(formDataValues.appointmentDate),
      "slotId": slotObj.slotId,
      "slotTime": slotObj.slotTime,
      "rescheduleBy" : UserId,
    }

    this.hcService.RescheduleCorporateHCAppointment(payload).subscribe((res: any) => {

      if (res.appointmentId > 0) {
        this.callCenterService.afterCompleteOperationKnowTheStatus({
          "callStatusId": this.CallerStatusAutoId,
          "isOperationDone": true,
          "statusMessage": "corp HC Appt Reschedule Successfully."
        });
        this.messageService.showSuccess(res['errorMsg']);
        this.closeConfirmModal();
      }
      else {
        this.messageService.showErrorMessage(res['errorMsg']);
      }
    })

  }

  statusRemarks: any;
  CancelAppointment() {
    let UserId = JSON.parse(localStorage.getItem('LOGGED_USER_INFO')).roleId;
    if (this.statusRemarks != "") {
      let payload = {
        "appointmentId": this.selectedApptDetails.appointmentId,
        "comments": this.statusRemarks,
        "modifiedBy" : UserId,
      }
     
      this.hcService.CancelCorporateHCAppointment(payload).subscribe((res: any) => {
       
        if (res.appointmentId > 0) {
          this.callCenterService.afterCompleteOperationKnowTheStatus({
            "callStatusId": this.CallerStatusAutoId,
            "isOperationDone": true,
            "statusMessage": "corp. HC Appt Cancelled Successfully."
          });
          this.messageService.showSuccess(res['errorMsg']);
          this.closeConfirmModal();
        }
        else {
          this.messageService.showErrorMessage(res['errorMsg']);
        }
      })

    } else {
      this.messageService.showErrorMessage("Required Call Remarks");
    }
  }


}
